import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, isRef as _isRef, vModelSelect as _vModelSelect, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "admin-dashboard" }
const _hoisted_2 = { class: "container-fluid dashboard-content" }
const _hoisted_3 = { class: "container-fluid dashboard-content" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = { class: "card" }
const _hoisted_7 = { class: "card-header" }
const _hoisted_8 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "card-body" }
const _hoisted_11 = ["value"]

import { shallowRef } from 'vue';
import SectionHeader from './components/SectionHeader.vue';
import UsersTabs from './components/UsersTabs.vue';
import AccountKpis from './components/AccountKpis.vue';
import OperationsKpis from './components/OperationsKpis.vue';
import UsersCharts from './components/UsersCharts.vue';
import StudentsTable from './students/StudentsTable.vue';
import EmployeesTable from './employees/EmployeesTable.vue';
import { useUsersDashboardData } from './composables/useUsersDashboardData.js';


export default {
  __name: 'UsersDashboard',
  props: {
  accountsApiUrl: {
    type: String,
    required: true,
  },
},
  setup(__props) {



const activeTab = shallowRef('students');

const {
  analyticsRangeDays,
  studentsData,
  employeesList,
  lowBudgetStudents,
  accountAnalytics,
  isBaseLoading,
  isBookingsLoading,
  baseError,
  analyticsError,
  isRefreshDisabled,
  isRefreshing,
  refreshAllData,
} = useUsersDashboardData();

const rangeOptions = [7, 14, 30];

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" Error State "),
    _withDirectives(_createElementVNode("div", _hoisted_2, [...(_cache[3] || (_cache[3] = [
      _createElementVNode("div", { class: "row" }, [
        _createElementVNode("div", { class: "col-12" }, [
          _createElementVNode("div", { class: "card" }, [
            _createElementVNode("div", { class: "card-body" }, [
              _createElementVNode("div", {
                class: "alert alert-danger",
                role: "alert"
              }, [
                _createElementVNode("i", { class: "fas fa-exclamation-triangle me-2" }),
                _createTextVNode(" Benutzerkonten-API-URL fehlt. Die Benutzerkontenverwaltung kann nicht geladen werden. ")
              ])
            ])
          ])
        ])
      ], -1 /* CACHED */)
    ]))], 512 /* NEED_PATCH */), [
      [_vShow, !__props.accountsApiUrl]
    ]),
    _createCommentVNode(" Main Content "),
    _withDirectives(_createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _cache[4] || (_cache[4] = _createElementVNode("div", null, [
                  _createElementVNode("h5", { class: "card-title mb-1" }, " Benutzerkonten "),
                  _createElementVNode("p", { class: "text-muted mb-0" }, " Verwalten Sie Studenten- und Mitarbeiterkonten ")
                ], -1 /* CACHED */)),
                _createElementVNode("button", {
                  class: "btn btn-sm btn-outline-secondary",
                  disabled: _unref(isRefreshDisabled),
                  title: "Aktualisieren",
                  "aria-label": "Aktualisieren",
                  onClick: _cache[0] || (_cache[0] = (...args) => (_unref(refreshAllData) && _unref(refreshAllData)(...args)))
                }, [
                  _createElementVNode("i", {
                    class: _normalizeClass(["fas fa-sync-alt", { 'fa-spin': _unref(isRefreshing) }])
                  }, null, 2 /* CLASS */)
                ], 8 /* PROPS */, _hoisted_9)
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createCommentVNode(" Snapshot: independent of the selected period "),
              _createVNode(SectionHeader, {
                title: "Konten & Budgetstatus",
                icon: "fas fa-user-graduate",
                "icon-color-class": "text-primary",
                meta: "Aktueller Stand"
              }),
              _createVNode(AccountKpis, {
                students: _unref(studentsData) || [],
                employees: _unref(employeesList),
                "low-budget-students": _unref(lowBudgetStudents),
                loading: _unref(isBaseLoading),
                error: _unref(baseError)
              }, null, 8 /* PROPS */, ["students", "employees", "low-budget-students", "loading", "error"]),
              _createCommentVNode(" Booking analysis: everything below follows the selected period "),
              _createVNode(SectionHeader, {
                title: "Buchungsanalyse",
                icon: "fas fa-chart-line",
                "icon-color-class": "text-warning",
                meta: `Letzte ${_unref(analyticsRangeDays)} Tage`
              }, {
                actions: _withCtx(() => [
                  _cache[5] || (_cache[5] = _createElementVNode("label", {
                    for: "analytics-range-days",
                    class: "form-label mb-0 small text-muted"
                  }, "Zeitraum:", -1 /* CACHED */)),
                  _withDirectives(_createElementVNode("select", {
                    id: "analytics-range-days",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_isRef(analyticsRangeDays) ? (analyticsRangeDays).value = $event : null)),
                    class: "form-select form-select-sm",
                    style: {"width":"auto"}
                  }, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(rangeOptions, (days) => {
                      return _createElementVNode("option", {
                        key: days,
                        value: days
                      }, _toDisplayString(days) + " Tage ", 9 /* TEXT, PROPS */, _hoisted_11)
                    }), 64 /* STABLE_FRAGMENT */))
                  ], 512 /* NEED_PATCH */), [
                    [
                      _vModelSelect,
                      _unref(analyticsRangeDays),
                      void 0,
                      { number: true }
                    ]
                  ])
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["meta"]),
              _createVNode(UsersCharts, {
                "range-days": _unref(analyticsRangeDays),
                analytics: _unref(accountAnalytics) || null,
                "bookings-loading": _unref(isBookingsLoading),
                "analytics-error": _unref(analyticsError)
              }, null, 8 /* PROPS */, ["range-days", "analytics", "bookings-loading", "analytics-error"]),
              _createCommentVNode(" Raumnutzung & Buchungsbetrieb "),
              _createVNode(OperationsKpis, {
                analytics: _unref(accountAnalytics) || null,
                loading: _unref(isBookingsLoading),
                error: _unref(analyticsError)
              }, null, 8 /* PROPS */, ["analytics", "loading", "error"]),
              _createCommentVNode(" Tabs "),
              _createVNode(UsersTabs, {
                "active-tab": activeTab.value,
                "onUpdate:activeTab": _cache[2] || (_cache[2] = $event => (activeTab.value = $event))
              }, null, 8 /* PROPS */, ["active-tab"]),
              _createCommentVNode(" Students Table "),
              _withDirectives(_createVNode(StudentsTable, null, null, 512 /* NEED_PATCH */), [
                [_vShow, activeTab.value === 'students']
              ]),
              _createCommentVNode(" Employees Table "),
              _withDirectives(_createVNode(EmployeesTable, null, null, 512 /* NEED_PATCH */), [
                [_vShow, activeTab.value === 'employees']
              ])
            ])
          ])
        ])
      ])
    ], 512 /* NEED_PATCH */), [
      [_vShow, __props.accountsApiUrl]
    ])
  ]))
}
}

}